import React, { useState, ChangeEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { connect } from 'react-redux';
import { AnyAction, Dispatch, bindActionCreators } from 'redux';
import { forgotPassword } from '../../store/actions/auth';
import TextInput from '../../components/TextInput';
import { Link } from 'react-router-dom';
import { checkIsValidEmail } from '../../services/utilService';
import { MESSAGES } from '../../services/constants';


const ForgotPassword = (props: any) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const checkValidation = (value: string) => {
        if(!value) {
            setError(MESSAGES.requiredField('Email'));
            return false;
        }
        if(!checkIsValidEmail(value)) {
            setError(MESSAGES.emailIsInvalid);
            return false;
        }
        return true;
    }
    const handleChange = (e:ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
        const valid = checkValidation(e.target.value);
        if(valid) {
            setError('');
        }
    }
    const forgotPassword = async(e) => {
        e.preventDefault();
        const valid = checkValidation(email);
        if(!valid) {
            return;   
        }
        setError('');
        const forgotDone = await props.doForgotPassword(email);

        if(forgotDone) {
            props.history.push('/login');
        }
    }
    return (
    <div className="login-center">
        <div className="login-wrapper">
            <div className="login-top">
                <img src="assets/images/logo.png" />
            </div>
            <div className="text-center">
               <h3>Forgot Password</h3>
            </div>
            <div className="login-content">
                <form className="witt-form login-form">
                    <div className="form-group">
                        <FontAwesomeIcon icon={faEnvelope} />
                        <TextInput  
                        type="email"
                        placeholder="Email" 
                        value={email}
                        name="Email"
                        error={error}
                        onChange={handleChange}
                         />
                    </div>
                    <div className="login-action text-center">
                        <button disabled={props.isLoading} type="submit" className="btn btn-primary w-100" onClick={(e: any) => forgotPassword(e)}>Submit</button>
                        <Link className="mt-5 forgot-pass" to="/login">Back to Login</Link>
                    </div>
                </form>
            </div>
        </div>
    </div>
   )
}

const mapStateToProps = (state: any) => ({
    isLoading: state.common.isLoading

})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
    doForgotPassword:  bindActionCreators(forgotPassword,dispatch),
});


        
export default connect(mapStateToProps,mapDispatchToProps)(ForgotPassword);